export default "__VITE_ASSET__qd_nVYst__"